import DialogActions from '@mui/material/DialogActions'
import DialogTitle from '@mui/material/DialogTitle'
import { useTranslation } from 'react-i18next'
import React, { useEffect } from 'react'

import ContainedButton from 'shared/components/Buttons/ContainedButton'
import CustomDialog from 'shared/components/CustomDialog'

import DeleteReflinkModalContent from './components/DeleteReflinkModalContent'
import EditReflinkModalContent from './components/EditReflinkModalContent'
import AddReflinkModalContent from './components/AddReflinkModalContent'
import SmsModal from './components/SmsModalContent'
import { ModalInfoType } from '../../types'
import AddCustomerModal from './components/AddCustomerModal'

interface Props {
   handleClose: () => void
   modalInfo: ModalInfoType
}

export default function Modal({ handleClose, modalInfo }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'CLIENTS_CARTS'])

   function renderForm() {
      switch (modalInfo.modalType) {
         case 'NEW_CUSTOMER':
            return (
               <AddCustomerModal
                  reflinkSettings={modalInfo.reflinkSettings}
                  handleClose={handleClose}
                  phoneNumber={modalInfo.reflinkSettings?.phoneNumber || ''}
                  email={modalInfo.reflinkSettings?.email || ''}
                  cartName={modalInfo.reflinkSettings?.cartName || ''}
                  markup={modalInfo.reflinkSettings?.markupSettings || null}
               />
            )
         case 'IN_PROGRESS':
         case 'SENT':
            return (
               <DialogActions>
                  <ContainedButton onClick={handleClose} variant="contained">
                     {t('TRANSLATION:understand')}
                  </ContainedButton>
               </DialogActions>
            )
         case 'CREATE':
            return <AddReflinkModalContent handleClose={handleClose} />
         case 'DELETE':
            return (
               <DeleteReflinkModalContent
                  reflinkUuid={modalInfo.reflinkSettings?.uuid || ''}
                  handleClose={handleClose}
               />
            )
         case 'EDIT':
            return (
               <EditReflinkModalContent
                  reflinkUuid={modalInfo.reflinkSettings?.uuid || ''}
                  reflinkSettings={modalInfo.reflinkSettings}
                  handleClose={handleClose}
               />
            )
         case 'SMS':
            return (
               <SmsModal
                  notificationSentDate={modalInfo.notificationSentDate || null}
                  phone={modalInfo.reflinkSettings!.phoneNumber!}
                  handleClose={handleClose}
                  reflink={modalInfo.reflinkSettings!.uuid!}
               />
            )
         default:
            return null
      }
   }

   return (
      <CustomDialog
         open={modalInfo.open}
         isLoading={!modalInfo}
         deleteVariant={modalInfo.modalType === 'DELETE'}
         maxWidth={
            modalInfo.modalType === 'CREATE' || modalInfo.modalType === 'EDIT' || modalInfo.modalType === 'NEW_CUSTOMER'
               ? 'lg'
               : 'sm'
         }
         fullWidth={modalInfo.modalType === 'SMS' || modalInfo.modalType === 'EDIT' || modalInfo.modalType === 'CREATE'}
         onClose={handleClose}
         content={
            <>
               <DialogTitle>{t(`CLIENTS_CARTS:${modalInfo.modalType}`)}</DialogTitle>
               {renderForm()}
            </>
         }
      />
   )
}
